/*  ========================================================================
    # Scripts - Header (Mobile)
    ========================================================================  */

/**
 * Script that handles opening/closing the mobile menu
 */

const HeaderMobile = {
  cfg: {
    menuButton: document.querySelector('.c-header-mobile__menu-button'),
    menuItems: document.querySelectorAll('.c-header-mobile__menu a'),
    header: document.querySelector('.c-header-mobile'),
    body: document.querySelector('body'),
    mobileMenu: document.querySelector('.c-header-mobile__menu')
  },

  /**
   * Initialize.
   */
  init() {
    this.cfg.menuButton.addEventListener('click', event => {
      event.stopPropagation();

      window.scrollTo({ top: 0, behavior: 'smooth' });

      this.cfg.header.toggleAttribute('data-opened');
      this.cfg.body.toggleAttribute('data-fixed');

      // Close all opened submenus when opening/closing menu
      this.cfg.mobileMenu
        ?.querySelectorAll('.menu-item-has-children.is-open')
        .forEach(el => el.classList.remove('is-open'));
    });

    this.cfg.menuItems.forEach(item =>
      item.addEventListener('click', () => {
        this.cfg.header.removeAttribute('data-opened');
        this.cfg.body.removeAttribute('data-fixed');
      })
    );

    // Submenu toggle
    document.addEventListener('click', event => {
      if (event.target.classList.contains('submenu-toggle')) {
        event.preventDefault();

        event.target
          .closest('.menu-item-has-children')
          ?.classList.toggle('is-open');
      }
    });
  }
};

export default HeaderMobile;